/* StayRare theme — product card reveal-on-scroll */
(function(){
  var cards = document.querySelectorAll('.card');
  if (!cards.length) return;

  if (!('IntersectionObserver' in window)) {
    cards.forEach(function(c){ c.classList.add('in'); });
    return;
  }

  var io = new IntersectionObserver(function(entries){
    entries.forEach(function(entry){
      if (entry.isIntersecting){
        entry.target.classList.add('in');
        io.unobserve(entry.target);
      }
    });
  }, { rootMargin: '0px 0px -40px 0px', threshold: 0.05 });

  cards.forEach(function(c){ io.observe(c); });
})();

/* StayRare theme — gate + ambient particle field. Decorative, no Shopify data. */
(function(){
  var gate = document.getElementById('gate');
  if (!gate) return;
  if (sessionStorage.getItem('stayrare_entered')) {
    document.documentElement.classList.add('no-gate');
    return;
  }
  document.body.classList.add('gate-lock');

  var tilt = gate.querySelector('.gate-tilt');
  var pointer = document.getElementById('gatePointer');
  var flash = document.getElementById('gateFlash');
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  function hexLerp(a,b,t){
    a=a.replace('#',''); b=b.replace('#','');
    var ar=parseInt(a.substr(0,2),16), ag=parseInt(a.substr(2,2),16), ab=parseInt(a.substr(4,2),16);
    var br=parseInt(b.substr(0,2),16), bg=parseInt(b.substr(2,2),16), bb=parseInt(b.substr(4,2),16);
    var r=Math.round(ar+(br-ar)*t), g=Math.round(ag+(bg-ag)*t), bl=Math.round(ab+(bb-ab)*t);
    return 'rgb('+r+','+g+','+bl+')';
  }
  function extrude(el, depth, from, to){
    if (!el) return;
    var parts = [];
    for (var i=1;i<=depth;i++){
      parts.push((i*0.55)+'px '+(i*0.55)+'px 0 '+hexLerp(from,to,i/depth));
    }
    parts.push('0 '+(depth*0.6+18)+'px 26px rgba(0,0,0,0.55)');
    el.style.textShadow = parts.join(',');
  }
  extrude(gate.querySelector('.g-stay'), 26, '#F4EFE8', '#5b564e');
  extrude(gate.querySelector('.g-rare'), 26, '#B87CFF', '#2A0F4A');

  var SVG_NS = 'http://www.w3.org/2000/svg';
  function buildTicks(svg, count, rIn, rOut, cx, cy, stroke){
    if (!svg) return;
    for (var i=0;i<count;i++){
      var a = (i/count)*Math.PI*2;
      var line = document.createElementNS(SVG_NS,'line');
      line.setAttribute('x1', cx+rIn*Math.cos(a));
      line.setAttribute('y1', cy+rIn*Math.sin(a));
      line.setAttribute('x2', cx+rOut*Math.cos(a));
      line.setAttribute('y2', cy+rOut*Math.sin(a));
      line.setAttribute('stroke', stroke);
      line.setAttribute('stroke-width', '1');
      svg.appendChild(line);
    }
  }
  function buildDiamonds(svg, r, cx, cy, size, fill){
    if (!svg) return;
    [0,90,180,270].forEach(function(deg){
      var a = deg*Math.PI/180;
      var x = cx+r*Math.cos(a), y = cy+r*Math.sin(a);
      var d = document.createElementNS(SVG_NS,'path');
      d.setAttribute('d', 'M'+x+' '+(y-size)+' L'+(x+size)+' '+y+' L'+x+' '+(y+size)+' L'+(x-size)+' '+y+' Z');
      d.setAttribute('fill', fill);
      svg.appendChild(d);
    });
  }
  function buildVitruvian(svg, cx, cy, stroke){
    if (!svg) return;
    function line(x1,y1,x2,y2){
      var l = document.createElementNS(SVG_NS,'line');
      l.setAttribute('x1',x1); l.setAttribute('y1',y1);
      l.setAttribute('x2',x2); l.setAttribute('y2',y2);
      l.setAttribute('stroke', stroke); l.setAttribute('stroke-width','1.2');
      l.setAttribute('stroke-linecap','round');
      l.setAttribute('class','vitruvian');
      svg.appendChild(l);
    }
    var head = document.createElementNS(SVG_NS,'circle');
    head.setAttribute('cx', cx); head.setAttribute('cy', cy-95); head.setAttribute('r', 13);
    head.setAttribute('fill','none'); head.setAttribute('stroke', stroke); head.setAttribute('stroke-width','1.2');
    head.setAttribute('class','vitruvian');
    svg.appendChild(head);
    line(cx, cy-80, cx, cy+15);
    line(cx-22, cy-75, cx+22, cy-75);
    line(cx-13, cy+15, cx+13, cy+15);
    line(cx+22, cy-75, cx+90, cy-107);
    line(cx-22, cy-75, cx-90, cy-107);
    line(cx+13, cy+15, cx+80, cy+115);
    line(cx-13, cy+15, cx-80, cy+115);
  }
  function setupRingDraw(svg){
    if (!svg) return;
    var circles = svg.querySelectorAll('circle');
    circles.forEach(function(c){
      var r = parseFloat(c.getAttribute('r'));
      var circ = 2*Math.PI*r;
      c.style.strokeDasharray = circ + ' ' + circ;
      c.style.setProperty('--circ', circ);
    });
  }

  var sigilOuter = document.getElementById('sigilOuter');
  var sigilMid = document.getElementById('sigilMid');
  var sigilInner = document.getElementById('sigilInner');
  buildTicks(sigilOuter, 24, 168, 186, 200, 200, 'rgba(231,229,226,0.32)');
  buildDiamonds(sigilOuter, 178, 200, 200, 6, 'rgba(109,40,217,0.55)');
  buildVitruvian(sigilMid, 200, 200, 'rgba(109,40,217,0.5)');
  buildTicks(sigilInner, 8, 96, 120, 200, 200, 'rgba(109,40,217,0.4)');
  setupRingDraw(sigilOuter);
  setupRingDraw(sigilMid);
  setupRingDraw(sigilInner);

  function initEmbers(canvas){
    if (!canvas) return;
    var ectx = canvas.getContext('2d');
    var eW, eH, eDPR = Math.min(window.devicePixelRatio||1, 2);
    function eResize(){
      var r = canvas.getBoundingClientRect();
      eW = r.width; eH = r.height;
      canvas.width = Math.max(1, eW*eDPR); canvas.height = Math.max(1, eH*eDPR);
      ectx.setTransform(eDPR,0,0,eDPR,0,0);
    }
    eResize();
    window.addEventListener('resize', eResize);
    var embers = [];
    for (var i=0;i<26;i++){
      embers.push({
        x: Math.random()*eW, y: Math.random()*eH, r: Math.random()*1.6+0.6,
        vy: -(Math.random()*0.35+0.15), sway: Math.random()*0.4+0.12, phase: Math.random()*Math.PI*2,
        accent: Math.random() < 0.4
      });
    }
    function eDraw(){
      ectx.clearRect(0,0,eW,eH);
      for (var i=0;i<embers.length;i++){
        var p = embers[i];
        ectx.beginPath();
        ectx.arc(p.x, p.y, p.r, 0, Math.PI*2);
        ectx.fillStyle = p.accent ? 'rgba(109,40,217,0.55)' : 'rgba(231,229,226,0.4)';
        ectx.fill();
      }
    }
    if (reduced){ eDraw(); return; }
    var eLast = null;
    function eLoop(t){
      if (eLast == null) eLast = t;
      eLast = t;
      for (var i=0;i<embers.length;i++){
        var p = embers[i];
        p.y += p.vy;
        p.x += Math.sin(t/1000*p.sway+p.phase)*0.15;
        if (p.y < -6){ p.y = eH+6; p.x = Math.random()*eW; }
      }
      eDraw();
      requestAnimationFrame(eLoop);
    }
    requestAnimationFrame(eLoop);
  }
  initEmbers(document.getElementById('gateEmbers'));

  setTimeout(function(){
    gate.classList.add('ready');
    tilt.style.opacity = '1';
    setTimeout(function(){ tilt.classList.add('idle'); }, 1000);
  }, 30);
  gate.focus();

  if (!reduced && !(window.matchMedia && window.matchMedia('(pointer: coarse)').matches)) {
    gate.addEventListener('pointermove', function(e){
      var r = gate.getBoundingClientRect();
      var x = ((e.clientX - r.left) / r.width) * 2 - 1;
      var y = ((e.clientY - r.top) / r.height) * 2 - 1;
      pointer.style.transform = 'rotateY(' + (x*10) + 'deg) rotateX(' + (-y*10) + 'deg)';
    });
    gate.addEventListener('pointerleave', function(){
      pointer.style.transform = 'rotateY(0deg) rotateX(0deg)';
    });
  }

  function proceed(){
    if (gate.classList.contains('leaving')) return;
    gate.classList.add('leaving');
    tilt.style.opacity = '';
    if (flash) flash.classList.add('flash');
    sessionStorage.setItem('stayrare_entered', '1');
    document.body.classList.remove('gate-lock');
    setTimeout(function(){
      gate.style.display = 'none';
      if (flash) flash.style.display = 'none';
    }, 750);
  }

  gate.addEventListener('click', proceed);
  gate.addEventListener('keydown', function(e){
    if (e.key === 'Enter' || e.key === ' ' || e.key === 'Spacebar'){
      e.preventDefault();
      proceed();
    }
  });
})();

/* Ambient particle field (left/right margins) */
(function(){
  var reduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var mq = window.matchMedia('(min-width: 1440px)');
  /* 5-point star layout: a center dot plus 2 dots along each of the 5 spokes, matching paintCross's shape */
  var CROSS = [
    [0,0],
    [0,-1.6],[1.52,-0.49],[0.94,1.29],[-0.94,1.29],[-1.52,-0.49],
    [0,-3.2],[3.04,-0.99],[1.88,2.59],[-1.88,2.59],[-3.04,-0.99]
  ];

  function Field(canvas){
    this.canvas = canvas;
    this.ctx = canvas.getContext('2d');
    this.particles = [];
    this.assembled = [];
    this.state = 'idle';
    this.timer = 0;
    this.delay = 5 + Math.random()*4;
    this.running = false;
    this.raf = null;
    this.spacing = 15;
    this.count = 16;
  }
  Field.prototype.rand = function(a,b){ return a + Math.random()*(b-a); };
  Field.prototype.resize = function(){
    var rect = this.canvas.getBoundingClientRect();
    this.W = rect.width; this.H = rect.height;
    var dpr = Math.min(window.devicePixelRatio||1, 2);
    this.canvas.width = Math.max(1, this.W*dpr); this.canvas.height = Math.max(1, this.H*dpr);
    this.ctx.setTransform(dpr,0,0,dpr,0,0);
  };
  Field.prototype.init = function(){
    this.resize();
    this.particles = [];
    for (var i=0;i<this.count;i++){
      this.particles.push({
        x:this.rand(0,this.W), y:this.rand(0,this.H),
        vx:this.rand(-0.12,0.12), vy:this.rand(-0.08,0.08),
        r:this.rand(1.3,2.5), accent: Math.random() < 0.35,
        tx:null, ty:null, phase:Math.random()*Math.PI*2
      });
    }
  };
  Field.prototype.pickTargets = function(){
    var cx = this.W*0.5, cy = this.H*this.rand(0.18,0.72);
    this.formCx = cx; this.formCy = cy;
    var n = Math.min(CROSS.length, this.particles.length);
    var idxs = this.particles.map(function(_,i){ return i; });
    idxs.sort(function(){ return 0.5-Math.random(); });
    this.assembled = [];
    var i, p;
    for (i=0;i<n;i++){
      p = this.particles[idxs[i]];
      p.tx = cx + CROSS[i][0]*this.spacing;
      p.ty = cy + CROSS[i][1]*this.spacing;
      this.assembled.push(p);
    }
    for (i=n;i<idxs.length;i++){
      p = this.particles[idxs[i]];
      p.tx = null; p.ty = null;
    }
  };
  Field.prototype.update = function(dt){
    this.timer += dt;
    var p, i;
    if (this.state === 'idle'){
      for (i=0;i<this.particles.length;i++){
        p = this.particles[i];
        p.x += p.vx; p.y += p.vy;
        if (p.x < -6) p.x = this.W+6; if (p.x > this.W+6) p.x = -6;
        if (p.y < -6) p.y = this.H+6; if (p.y > this.H+6) p.y = -6;
      }
      if (this.timer > this.delay){ this.pickTargets(); this.state = 'assembling'; this.timer = 0; }
    } else if (this.state === 'assembling'){
      var t = Math.min(1, this.timer/1.8);
      for (i=0;i<this.particles.length;i++){
        p = this.particles[i];
        if (p.tx != null){ p.x += (p.tx-p.x)*0.1; p.y += (p.ty-p.y)*0.1; }
        else { p.x += p.vx*0.25; p.y += p.vy*0.25; }
      }
      if (t >= 1){ this.state = 'holding'; this.timer = 0; }
    } else if (this.state === 'holding'){
      for (i=0;i<this.particles.length;i++){
        p = this.particles[i];
        if (p.tx != null){
          p.x += Math.sin(this.timer*2+p.phase)*0.04;
          p.y += Math.cos(this.timer*2+p.phase)*0.04;
        }
      }
      if (this.timer > 2.3){
        this.state = 'dispersing'; this.timer = 0;
        for (i=0;i<this.particles.length;i++){
          this.particles[i].vx = this.rand(-0.18,0.18);
          this.particles[i].vy = this.rand(-0.14,0.14);
        }
      }
    } else if (this.state === 'dispersing'){
      for (i=0;i<this.particles.length;i++){
        p = this.particles[i]; p.x += p.vx; p.y += p.vy;
      }
      if (this.timer > 1.5){
        this.state = 'idle'; this.timer = 0; this.delay = 6+Math.random()*5;
        for (i=0;i<this.particles.length;i++){ this.particles[i].tx = null; this.particles[i].ty = null; }
        this.assembled = [];
      }
    }
  };
  Field.prototype.paintCross = function(cx, cy, s){
    var ctx = this.ctx;
    var len = 15*s, lineW = 7.5*s, centerR = 4.3*s;
    var grad = ctx.createRadialGradient(cx, cy, 0, cx, cy, len);
    grad.addColorStop(0, '#c9a3ff');
    grad.addColorStop(1, '#ffffff');
    ctx.fillStyle = grad;
    ctx.beginPath(); ctx.arc(cx, cy, centerR, 0, Math.PI*2); ctx.fill();

    ctx.strokeStyle = grad;
    ctx.lineWidth = lineW;
    ctx.lineCap = 'square';
    var points = 5; /* 5 spokes from the center = a 5-point star/asterisk */
    for (var i=0; i<points; i++){
      var angle = -Math.PI/2 + i*(Math.PI*2/points);
      var dx = Math.cos(angle)*len, dy = Math.sin(angle)*len;
      ctx.beginPath();
      ctx.moveTo(cx, cy);
      ctx.lineTo(cx+dx, cy+dy);
      ctx.stroke();
    }
  };
  Field.prototype.draw = function(){
    var ctx = this.ctx;
    ctx.clearRect(0,0,this.W,this.H);
    var glow = 0;
    if (this.state === 'holding'){ glow = 1; }
    else if (this.state === 'assembling'){ glow = Math.min(1, this.timer/1.8); }
    else if (this.state === 'dispersing'){ glow = Math.max(0, 1 - this.timer/1.5); glow = glow*glow; }
    if (glow > 0.12 && this.formCx != null){
      var scale = Math.min(1.2, this.W/140);
      ctx.save();
      ctx.globalAlpha = glow;
      ctx.shadowColor = 'rgba(109,40,217,0.9)';
      ctx.shadowBlur = 18;
      this.paintCross(this.formCx, this.formCy, scale);
      ctx.restore();
    }
    for (var i=0;i<this.particles.length;i++){
      var p = this.particles[i];
      var pg = p.tx != null ? glow : 0;
      ctx.beginPath();
      ctx.arc(p.x, p.y, p.r + pg*0.7, 0, Math.PI*2);
      ctx.fillStyle = p.accent
        ? 'rgba(109,40,217,' + (0.4+pg*0.45) + ')'
        : 'rgba(231,229,226,' + (0.3+pg*0.4) + ')';
      ctx.fill();
    }
  };
  Field.prototype.start = function(){
    if (this.running) return;
    this.running = true;
    this.init();
    if (reduced){ this.draw(); return; }
    var self = this, last = null;
    function loop(t){
      if (!self.running) return;
      if (last == null) last = t;
      var dt = Math.min(0.05, (t-last)/1000); last = t;
      self.update(dt); self.draw();
      self.raf = requestAnimationFrame(loop);
    }
    this.raf = requestAnimationFrame(loop);
  };
  Field.prototype.stop = function(){
    this.running = false;
    if (this.raf) cancelAnimationFrame(this.raf);
  };

  var leftCanvas = document.getElementById('particlesLeft');
  var rightCanvas = document.getElementById('particlesRight');
  if (!leftCanvas || !rightCanvas) return;
  var fieldL = new Field(leftCanvas);
  var fieldR = new Field(rightCanvas);

  function sync(){
    if (mq.matches){ fieldL.start(); fieldR.start(); }
    else { fieldL.stop(); fieldR.stop(); }
  }
  if (mq.addEventListener) mq.addEventListener('change', sync);
  else if (mq.addListener) mq.addListener(sync);

  var resizeTimer;
  window.addEventListener('resize', function(){
    clearTimeout(resizeTimer);
    resizeTimer = setTimeout(function(){
      if (mq.matches){ fieldL.resize(); fieldR.resize(); }
    }, 150);
  });

  sync();
})();

/* ---------- Shopify: variants, add-to-cart, cart drawer, cart page ---------- */
(function(){
  function updateCartCount(count){
    document.querySelectorAll('[data-cart-count]').forEach(function(el){ el.textContent = count; });
  }
  function formatMoney(cents){ return '$' + (cents/100).toFixed(2); }

  /* ---- Cart drawer ---- */
  var drawer = document.getElementById('cartDrawer');
  var drawerBody = document.getElementById('cartDrawerBody');
  var drawerFoot = document.getElementById('cartDrawerFoot');
  var drawerSubtotal = document.getElementById('cartDrawerSubtotal');

  function renderDrawer(cart){
    if (!drawerBody) return;
    if (!cart.items.length){
      drawerBody.innerHTML = '<p class="cart-drawer-empty">Your cart is empty.</p>';
      if (drawerFoot) drawerFoot.hidden = true;
      return;
    }
    var html = '';
    cart.items.forEach(function(item, i){
      var img = item.image ? item.image.replace(/(\.[a-z]+)(\?|$)/i, '_160x$1$2') : '';
      html += '<div class="cart-drawer-line">' +
        (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
        '<div class="cart-drawer-line-info">' +
          '<div class="cart-line-title">' + item.product_title + '</div>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<div class="cart-line-variant">' + item.variant_title + '</div>' : '') +
          '<div class="cart-drawer-line-controls">' +
            '<input type="number" min="0" class="cart-qty" value="' + item.quantity + '" data-drawer-qty="' + (i+1) + '">' +
            '<button type="button" class="cart-remove" data-drawer-remove="' + (i+1) + '">Remove</button>' +
          '</div>' +
        '</div>' +
        '<div class="cart-drawer-line-price">' + formatMoney(item.final_line_price) + '</div>' +
      '</div>';
    });
    drawerBody.innerHTML = html;
    if (drawerFoot){
      drawerFoot.hidden = false;
      if (drawerSubtotal) drawerSubtotal.textContent = formatMoney(cart.total_price);
    }
  }

  function refreshDrawer(){
    return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart){
      updateCartCount(cart.item_count);
      renderDrawer(cart);
      return cart;
    });
  }

  function openDrawer(){
    if (!drawer) return;
    refreshDrawer();
    drawer.classList.add('open');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.classList.add('cart-drawer-lock');
  }
  function closeDrawer(){
    if (!drawer) return;
    drawer.classList.remove('open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.classList.remove('cart-drawer-lock');
  }

  document.querySelectorAll('[data-cart-drawer-open]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      if (!drawer) return;
      e.preventDefault();
      openDrawer();
    });
  });
  document.querySelectorAll('[data-cart-drawer-close]').forEach(function(el){
    el.addEventListener('click', closeDrawer);
  });
  document.addEventListener('keydown', function(e){
    if (e.key === 'Escape') closeDrawer();
  });

  if (drawerBody){
    drawerBody.addEventListener('change', function(e){
      var input = e.target.closest('[data-drawer-qty]');
      if (!input) return;
      var line = input.getAttribute('data-drawer-qty');
      var qty = parseInt(input.value, 10) || 0;
      fetch('/cart/change.js', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({line: line, quantity: qty})
      }).then(refreshDrawer);
    });
    drawerBody.addEventListener('click', function(e){
      var btn = e.target.closest('[data-drawer-remove]');
      if (!btn) return;
      var line = btn.getAttribute('data-drawer-remove');
      fetch('/cart/change.js', {
        method: 'POST', headers: {'Content-Type':'application/json'},
        body: JSON.stringify({line: line, quantity: 0})
      }).then(refreshDrawer);
    });
  }

  /* Keep the header cart count correct on normal page loads too */
  refreshDrawer();

  function addToCart(variantId, qty, btn){
    if (!variantId) return;
    var originalText = btn ? btn.textContent : '';
    if (btn){ btn.disabled = true; btn.textContent = 'Adding…'; }
    fetch('/cart/add.js', {
      method: 'POST',
      headers: {'Content-Type':'application/json', 'Accept':'application/json'},
      body: JSON.stringify({id: variantId, quantity: qty || 1})
    })
    .then(function(r){
      if (!r.ok) return r.json().then(function(err){ throw err; });
      return r.json();
    })
    .then(function(){ return refreshDrawer(); })
    .then(function(){
      if (btn){ btn.textContent = 'Added ✓'; }
      openDrawer();
    })
    .catch(function(err){
      if (btn){ btn.textContent = 'Sold Out'; }
      if (window.console) console.error('StayRare: add to cart failed', err);
    })
    .finally(function(){
      setTimeout(function(){
        if (btn){ btn.disabled = false; btn.textContent = originalText; }
      }, 1800);
    });
  }

  document.querySelectorAll('[data-quick-add]').forEach(function(btn){
    btn.addEventListener('click', function(e){
      e.preventDefault();
      addToCart(btn.getAttribute('data-variant-id'), 1, btn);
    });
  });

  var form = document.getElementById('productForm');
  if (form){
    var variantsEl = document.getElementById('productVariants');
    var optionsEl = document.getElementById('productOptions');
    var variantsData = variantsEl ? JSON.parse(variantsEl.textContent) : [];
    var optionNames = optionsEl ? JSON.parse(optionsEl.textContent) : [];
    var selected = {};
    var priceEl = document.getElementById('pvPrice');
    var addBtn = document.getElementById('pvAdd');
    var variantIdInput = document.getElementById('pvVariantId');
    var unavailableMsg = document.getElementById('pvUnavailable');
    var mainImg = document.getElementById('pvMainImg');

    function findVariant(){
      for (var i=0;i<variantsData.length;i++){
        var v = variantsData[i], match = true;
        for (var j=0;j<optionNames.length;j++){
          var key = 'option' + (j+1);
          if (selected[optionNames[j]] && v[key] !== selected[optionNames[j]]){ match = false; break; }
        }
        if (match) return v;
      }
      return null;
    }
    function refresh(){
      var variant = findVariant();
      if (variant){
        if (variantIdInput) variantIdInput.value = variant.id;
        if (priceEl) priceEl.textContent = formatMoney(variant.price);
        if (variant.available){
          addBtn.disabled = false; addBtn.textContent = 'Add to Cart';
          if (unavailableMsg) unavailableMsg.hidden = true;
        } else {
          addBtn.disabled = true; addBtn.textContent = 'Sold Out';
          if (unavailableMsg) unavailableMsg.hidden = false;
        }
        if (variant.featured_image && variant.featured_image.src && mainImg){
          mainImg.src = variant.featured_image.src;
        }
      } else {
        addBtn.disabled = true; addBtn.textContent = 'Unavailable';
      }
    }

    form.querySelectorAll('[data-option-name]').forEach(function(group){
      var name = group.getAttribute('data-option-name');
      var initial = group.querySelector('.size-opt.active, .swatch-opt.active');
      if (initial) selected[name] = initial.getAttribute('data-value');
      group.querySelectorAll('[data-value]').forEach(function(btn){
        btn.addEventListener('click', function(){
          group.querySelectorAll('[data-value]').forEach(function(b){ b.classList.remove('active'); });
          btn.classList.add('active');
          selected[name] = btn.getAttribute('data-value');
          refresh();
        });
      });
    });
    refresh();

    form.addEventListener('submit', function(e){
      e.preventDefault();
      addToCart(variantIdInput.value, 1, addBtn);
    });
  }

  document.querySelectorAll('.thumb[data-full]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var mainImg = document.getElementById('pvMainImg');
      if (mainImg) mainImg.src = btn.getAttribute('data-full');
      document.querySelectorAll('.thumb').forEach(function(b){ b.classList.remove('active'); });
      btn.classList.add('active');
    });
  });

  document.querySelectorAll('[data-cart-qty]').forEach(function(input){
    input.addEventListener('change', function(){
      var line = input.getAttribute('data-cart-qty');
      var qty = parseInt(input.value, 10) || 0;
      fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({line: line, quantity: qty})
      }).then(function(){ window.location.reload(); });
    });
  });
  document.querySelectorAll('[data-cart-remove]').forEach(function(btn){
    btn.addEventListener('click', function(){
      var line = btn.getAttribute('data-cart-remove');
      fetch('/cart/change.js', {
        method:'POST', headers:{'Content-Type':'application/json'},
        body: JSON.stringify({line: line, quantity: 0})
      }).then(function(){ window.location.reload(); });
    });
  });
})();
